import { render, staticRenderFns } from "./OrdersMainPage.vue?vue&type=template&id=fb856b6c&scoped=true&"
import script from "./OrdersMainPage.vue?vue&type=script&lang=js&"
export * from "./OrdersMainPage.vue?vue&type=script&lang=js&"
import style0 from "./OrdersMainPage.vue?vue&type=style&index=0&id=fb856b6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb856b6c",
  null
  
)

export default component.exports